module.exports = __webpack_public_path__ + "static/img/3.a115ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lamikal/3.jpg
// module id = YKNy
// module chunks = 0